import { useEffect, useState } from "react";
import { Device } from "../../../globals/interfaces";
import styled from "styled-components";
import ActionIcon from "../../../components/custom/ActionIcon";
import ModalManage from "./ModalManage";
import apiClient from "../../../apiClient";
import _ from "lodash";
import { getTsDate, notify, omit } from "../../../utils";
import VirtualTable from "../../../components/custom/VirtualTable";
import { useAppContext } from "../../../context";

export default function ManageDevices({
    activeTab
}) {

    const { user } = useAppContext();
    const [devices, setDevices] = useState<Array<Device>>([]);
    const [selectedDevice, setSelectedDevice] = useState<Device>();
    const [modal, setModal] = useState(false);

    useEffect(() => {
        const getDevices = async () => {
            try {
                const res = await apiClient.get(`/device/${user.s_unit}`);
                setDevices(res.data);
            } catch (err) {
                alert(err);
            }
        }
        if (activeTab === 'manageDevices') {
            getDevices();
        }
    }, [activeTab, user.s_unit]);

    const handleCreateUpdate = (device?: Device) => {
        if (device) {
            setSelectedDevice(device);
        } else {
            setSelectedDevice(undefined);
        }
        setModal(true);
    }

    const createDevice = async (device: Device) => {
        try {
            const res = await apiClient.post('/device', device);
            setDevices(prev => {
                const copy = _.cloneDeep(prev);
                copy.push(res.data);
                return copy;
            });
            notify('Added');
            setModal(false);
        } catch (err) { }
    }

    const updateDevice = async (device: Device) => {
        try {
            const body = {
                ...omit(device, 'id'),
                modifiedAt: getTsDate(),
                modifiedBy: user.s_email
            };
            const res = await apiClient.put(`/device/${device.id}`, body);
            setDevices(prev => {
                const copy = _.cloneDeep(prev);
                const updateIndex = copy.findIndex(item => item.id === device.id);
                copy[updateIndex] = {
                    ...body,
                    id: device.id
                };
                return copy;
            });
            notify('Updated');
            setModal(false);
        } catch (err) {
            alert(err);
        }
    }

    const deleteDevice = async (device: Device) => {
        try {
            const res = await apiClient.delete(`/device/${device.id}`);
            setDevices(prev => {
                const filtered = prev.filter(item => item.id !== device.id);
                return filtered;
            });
            notify('Deleted');
            setModal(false);
        } catch (err) {
            alert(err);
        }
    }

    return (
        <div>
            <FlexContainer>
                <h4>Devices</h4>
                <ActionIcon type='add' onClick={handleCreateUpdate} />
            </FlexContainer>
            <VirtualTable
                data={devices}
                mapping={[{
                    name: 'ID',
                    value: 'deviceId'
                }, {
                    name: 'Name',
                    value: 'deviceName'
                }, {
                    name: 'Unit',
                    value: 'unit'
                }, {
                    name: 'Hidden',
                    value: 'hidden',
                    boolean: true
                }, {
                    name: 'Modified By',
                    value: 'modifiedBy',
                    email: true
                }, {
                    name: 'Modified',
                    value: 'modifiedAt',
                    datetime: true,
                    utc: true
                }]}
                handleClick={handleCreateUpdate}
            />
            <ModalManage
                modal={modal}
                setModal={setModal}
                selectedDevice={selectedDevice}
                unit={user.s_unit}
                createDevice={createDevice}
                updateDevice={updateDevice}
                deleteDevice={deleteDevice}
            />
        </div>
    );
}

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;